import request from "../utils/request"

export function fetchThemeList(params) {
  return request({
    url: "/admin/themes",
    method: "get",
    params
  })
}

export function fetchThemeDetail(themeCode) {
  return request({
    url: `/admin/themes/${themeCode}`,
    method: "get"
  })
}

export function saveTheme(data) {
  return request({
    url: "/admin/themes",
    method: "post",
    data
  })
}

export function deleteTheme(themeCode) {
  return request({
    url: `/admin/themes/${themeCode}`,
    method: "delete"
  })
}

export function fetchAppFeatures(params) {
  return request({
    url: "/admin/app-features",
    method: "get",
    params
  })
}

export function saveAppFeature(data) {
  return request({
    url: "/admin/app-features",
    method: "post",
    data
  })
}

export function uploadFeatureIcon(file) {
  const data = new FormData()
  data.append("file", file)
  return request({
    url: "/admin/app-features/icon/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export function fetchThemeFeatureIcons(themeCode) {
  return request({
    url: `/admin/themes/${themeCode}/feature-icons`,
    method: "get"
  })
}

export function saveThemeFeatureIcon(themeCode, data) {
  return request({
    url: `/admin/themes/${themeCode}/feature-icons`,
    method: "post",
    data
  })
}

export function fetchThemeAssets(themeCode, params) {
  return request({
    url: `/admin/themes/${themeCode}/assets`,
    method: "get",
    params
  })
}

export function saveThemeAsset(themeCode, data) {
  return request({
    url: `/admin/themes/${themeCode}/assets`,
    method: "post",
    data
  })
}

export function fetchThemePetTypeImages(themeCode) {
  return request({
    url: `/admin/themes/${themeCode}/pet-type-images`,
    method: "get"
  })
}

export function saveThemePetTypeImage(themeCode, data) {
  return request({
    url: `/admin/themes/${themeCode}/pet-type-images`,
    method: "post",
    data
  })
}

export function fetchThemeStyleTokens(themeCode, params) {
  return request({
    url: `/admin/themes/${themeCode}/style-tokens`,
    method: "get",
    params
  })
}

export function saveThemeStyleToken(themeCode, data) {
  return request({
    url: `/admin/themes/${themeCode}/style-tokens`,
    method: "post",
    data
  })
}
